import React, { useEffect, useRef } from 'react';
import AOS from 'aos';
import { Accordion } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import classes from '../../css/item.module.css';
import Tilt from 'react-parallax-tilt';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';


const ScanStrip = (props) => {
    const currentSelectedChain = useSelector(state => state.mainapp.chainSlice.currentChain);
    const coin = useSelector(state => state.mainapp.chainSlice.currentChain.scan.coin);
    const faucet = useSelector(state => state.mainapp.chainSlice.currentChain.scan.faucet);
    const stakeholder = useSelector(state => state.mainapp.chainSlice.currentChain.scan.stakeholder);


    return (
        <>
            <div className='scan-strip'>
                <div>
                    <p>{coin.name} Token</p>
                    <a href={
                        coin.url
                    } target='_blank'>
                        {coin.address}
                    </a>
                </div>
                <div>
                    <p>{stakeholder.name} Contract</p>
                    <a href={
                        stakeholder.url
                    } target='_blank'>
                        {stakeholder.address}
                    </a>
                </div>
                <div>
                    <p>{faucet.name} Contract</p>
                    <a href={faucet.url} target='_blank'>
                        {faucet.address}
                    </a>
                </div>
            </div>

        </>
    );
};

export default ScanStrip;
